import React, { useState } from "react"
import axios from "axios"
import { connect } from "react-redux"

const ContactBar = () => {
  let [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  })
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    })
    if (ok) {
      form.reset()
    }
  }
  const handleOnSubmit = e => {
    e.preventDefault()
    const form = e.target
    setServerState({ submitting: true })
    axios({
      method: "post",
      url: "https://getform.io/f/40e39d10-af4a-44c5-b698-4b27d5efdf7f",
      data: new FormData(form),
    })
      .then(r => {
        handleServerResponse(true, "Thanks! We've got your message.", form)
      })
      .catch(r => {
        handleServerResponse(false, r.response.data.error, form)
      })
  }
  return (
    <div id="contactBar">
      <form method="POST" onSubmit={handleOnSubmit}>
        {serverState.status ? (
          <div className="status-message">
            <h1 className={!serverState.status.ok ? "errorMsg" : ""}>
              {serverState.status.msg}
            </h1>
          </div>
        ) : (
          <>
            <div className="user-data">
              <input
                className="name"
                type="text"
                name="name"
                placeholder="Name"
              />
              <input
                className="email"
                type="email"
                name="email"
                placeholder="Email"
              />
            </div>
            <textarea
              className="message"
              type="text"
              name="message"
              placeholder="Type your message..."
            />
            <div className="button-container">
              <button type="submit">SUBMIT</button>
            </div>
          </>
        )}
      </form>
    </div>
  )
}

export default connect(state => ({}), null)(ContactBar)
